import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { ArrowLeft, ShieldCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { LakshLogo } from '@/components/LakshLogo';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${BACKEND_URL}/api/admin/auth/login`, { email: email.trim().toLowerCase(), password });
      localStorage.setItem('laksh_admin_token', data.token);
      localStorage.setItem('laksh_admin_user', JSON.stringify(data.user));
      toast.success('Welcome, admin');
      navigate('/admin/dashboard');
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#06100A] flex items-center justify-center px-4">
      <div className="w-full max-w-md space-y-8">
        <Link to="/" className="inline-flex items-center gap-2 text-gray-400 hover:text-white">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
        <LakshLogo height={40} />
        <div>
          <div className="flex items-center gap-2 mb-3 text-[#EF9F27] font-semibold">
            <ShieldCheck className="w-5 h-5" /> Admin Console
          </div>
          <h1 className="text-3xl font-bold text-white font-['Outfit']">Restricted access</h1>
          <p className="text-gray-400 mt-2">Sign in with your Laksh admin account</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-6" data-testid="admin-login-form">
          <div className="space-y-2">
            <Label htmlFor="admin-email" className="text-gray-300">Email</Label>
            <Input id="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="bg-[#0a1a12] border-white/20 text-white" data-testid="admin-login-email" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="admin-password" className="text-gray-300">Password</Label>
            <Input id="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="bg-[#0a1a12] border-white/20 text-white" data-testid="admin-login-password" />
          </div>
          <Button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full bg-[#EF9F27] hover:bg-[#EF9F27]/90 text-[#06100A] font-semibold">
            {loading ? 'Signing in...' : 'Sign in'}
          </Button>
        </form>
      </div>
    </div>
  );
}
